<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractEquipmentTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="equipment"
                        arrows >
                    <template slot="gofixTab:equipment">
                        <b-row>
                            <b-col md="3">
                                <split-pane :min-percent="25" :default-percent="60" split="horizontal" >
                                    <template slot="paneL">
                                        <gofix-card title="property" class="contractTree contractEquimentTree" v-bind:class="{'run-loading':loadingProperty}" >
                                            <template slot="gofixCard:right_header">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <router-link class="btn p-0" :to="`/v2/contract-client/${$route.params.id}/properties`">
                                                        <b-button class="icon-button" title="Edit" v-b-tooltip.hover>
                                                            <img height="18" src="img/iconPencil.png" alt />
                                                        </b-button>
                                                    </router-link>
                                                </div>
                                            </template>
                                            <div class="contenAbsolute">
                                                <div class="tree-view-properties">
                                                    <tree :data="treeData" :options="opts" @node:clicked="selectProperty" ref="treeViewProperties">
                                                        <div slot-scope="{ node }" class="node-container">{{ node.text }}</div>
                                                    </tree>
                                                </div>
                                            </div>
                                        </gofix-card>
                                    </template>
                                    <template slot="paneR">
                                        <gofix-card title="Equipment Structure" class="contractTree contractEquimentTree" v-bind:class="{'run-loading':loadingEquipmentStruct}">
                                            <template slot="gofixCard:right_header">
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <router-link class="mr-3 p-0" :to="`equipment/equipment-structure`">
                                                        <b-button title="Edit" v-b-tooltip.hover>
                                                            <img height="18" src="img/iconPencil.png" alt />
                                                        </b-button>
                                                    </router-link>
                                                    <b-dropdown :disabled ="!$checkRole($accessModule.equipment, 'create')" class="btn" right v-b-tooltip.hover title="Setting">
                                                        <b-dropdown-item @click="modals.importEquipGroup.open = true" href="javascript:void(0)">Import</b-dropdown-item>
                                                        <b-dropdown-item @click="modals.importCustomField.open = true" href="javascript:void(0)">Import custom fields</b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                            </template>
                                            <div class="contenAbsolute">
                                                <div class="tree-view-properties">
                                                    <tree :data="categoryEquipment" :options="optsCate" @node:clicked="selectCategory" ref="treeViewCategory">
                                                        <div slot-scope="{ node }" class="node-container">{{ node.text }}</div>
                                                    </tree>
                                                </div>
                                            </div>
                                        </gofix-card>
                                    </template>
                                </split-pane>
                            </b-col>
                            <b-col md="9" class="pl-0">
                                <gofix-card title="Property Detail">
                                    <b-row>
                                        <b-col md="3">
                                            <gofix-text-field label="property name" oneline>{{propertySelected && propertySelected.name ? propertySelected.name : "-"}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-text-field label="owner" oneline>{{propertySelected && propertySelected.owner ? propertySelected.owner : "-"}}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field label="address" oneline>{{propertySelected && propertySelected.addessText ? propertySelected.addessText : "-"}}</gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                                <gofix-card fullContent class="equipmentCardTable">
                                    <!-- scrollAbsolute -->
                                    <gofix-default-table
                                            class="noFullHeight scontract-equipment-scroll"
                                            :settings="tableConfig"
                                            :table-items="tableItems"
                                            :column-setting-contract-id="$route.params.id"
                                            @load-items="getTableData"
                                            @import-items="importEquipmentAction"
                                            @export="exportItems"
                                            @delete-items="deleteItems"
                                            @new-item="addItem"
                                            @row-click="moreItem"
                                            @get-column-settings="getColumnSettings"
                                            ref="gofixTable">
                                        <template slot="gofix_table:before-control-right">
                                            <div v-if="$refs.gofixTable && $refs.gofixTable.tableSelected.selected.length > 0" class="tableSendSelected mr-4" >
                                                <gofix-button label="Create Preventive Maintenance" @click="openPreventive" outline></gofix-button>
                                            </div>
                                        </template>
                                        <template :slot="'gofix_table:' + field.key" 
                                            v-if="field.is_customfield || ['root_path', 'view'].includes(field.key)" 
                                            slot-scope="data" 
                                            v-for="field in columnSettings"
                                        >
                                            <template v-if="field.is_customfield">
                                                {{data.item.custom_fields | getCustomValue(field.attribute_id,field.customfield.type)}}
                                            </template>
                                            <template v-if="field.key == 'root_path'">
                                                {{ data.item.location_info ? data.item.location_info.root_path : '--' }}
                                            </template>
                                            <template v-if="field.key == 'view' && routeLink">
                                                {{ data.item.location_info ? data.item.location_info.root_path : '--' }}
                                            </template>
                                        </template>
                                    </gofix-default-table>
                                </gofix-card>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>

        <!-- Preventive Maintenance -->
        <preventive-maintenance :selected="modals.preventive.selected" v-model="modals.preventive.open"></preventive-maintenance>

        <!-- Add equipment -->
        <modal-add-equipment :tree-selected="treeSelected" @addSuccess="reloadEquipment" v-model="modals.addEquipment.open"></modal-add-equipment>

        <!-- Import file -->
        <modal-import v-model="modals.importEquipGroup.open" @upload="uploadFileImport"/>
        <modal-import v-model="modals.importCustomField.open" @upload="uploadFileImportCustomfields"/>
        <!-- Export modal  -->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
        <b-progress :max="100" height="3rem" show-progress animated>
          <b-progress-bar :value="100">
            <span class="font-size-16">{{modals.export.process}}</span>
          </b-progress-bar>
        </b-progress>
      </b-modal>

    </div>
</template>

<script>
import tabData from '@/data/_tabs';
import {filters} from '@/_filterVar.js'
import {mapGetters} from "vuex";
import LiquorTree from "liquor-tree";
const modalAddEquipment = () => import('./c-main/modal-add-equipment')
const preventiveMaintenance = () => import('./c-main/preventive-maintenance')
import moment from 'moment';
export default {
  name: "equipment",
  components: {
    [LiquorTree.name]: LiquorTree,
    modalAddEquipment,
    preventiveMaintenance
  },
  data() {
    let filter = JSON.parse(JSON.stringify(filters['equipment']));
    return {
      contract_tab: tabData.client_contract,
      tableConfig: {
        name: 'client-contract-equipment',
        controls: {
          create: true,
          delete: true
        },
        filter: filter,
        buildFilter: true,
        page: 1,
        limit: 100,
        total: 0,
        useDatabaseView: true,
        sortColumn: "id",
        sortDirection: "desc",
      },
      tableItems: [],
      items: [],
      treeData: this.getData(),
      categoryEquipment: this.getCateData(),
      pages: {
        isCMS: '1',
        limit: 100,
        page: 1,
        totalPage: 0,
        filter: JSON.parse(JSON.stringify(filters['equipment']))
      },
      opts: {
        minFetchDelay: 500,
        fetchData: node => {
          node.isBatch = false;
          if (node.data.id == this.rootId) {
            return new Promise((resolve, reject) => {
              resolve([]);
            });
          }
          return new Promise((resolve, reject) => {
            global
                .axios(
                    `api/contracts/${this.$route.params.id}/tree-properties/${node.data.id}`, {
                      method: "GET",
                      params: {
                        is_active: true
                      },
                      headers: {
                        Accept: "application/json"
                      }
                    }
                )
                .then(response => {
                  if (this.nodeModel) {
                    if (this.nodeModel.data.id != this.nodeSelected.data.id) {
                      if (response.data.data) {
                        response.data.data.forEach((element, key) => {
                          response.data.data[key].data.address = element.get_address;
                        });
                      }
                      resolve(response.data.data);
                    } else resolve([]);
                  } else {
                    if (response.data.data) {
                      response.data.data.forEach((element, key) => {
                        response.data.data[key].data.address = element.get_address;
                      });
                    }
                    resolve(response.data.data);
                  }
                })
                .catch(error => reject(error));
          });
        }
      },
      optsCate: {
        minFetchDelay: 500,
        fetchData: node => {
          node.isBatch = false;
          if (node.data.id == this.CategoryrootId) {
            return new Promise((resolve, reject) => {
              resolve([]);
            });
          }
          return this.$store
              .dispatch("EquipmentV2Controller/getEquipmentCategory", {
                id: node.id,
                contract_id: this.$route.params.id
              })
              .then(response => {
                return response.data.data;
              });
        }
      },
      rootId: 1,
      CategoryrootId: 1,
      loadingProperty: true,
      loadingEquipmentStruct: true,
      categorySelected: null,
      propertySelected: null,
      modals: {
        importCustomField: {
          open: false,
          data: {
            contract_id: this.$route.params.id,
            file: null
          }
        },
        importEquipGroup: {
          open: false
        },
        addEquipment: {
          open: false
        },
        preventive: {
          open: false,
          selected: []
        },
        export:{
          open:false,
          loading:false,
          process:'Creating file csv',
          title: 'Export Data'
        }
      },
      columnSettings: [],
      treeSelected: {
        groups: null,
        location: null
      }
    };
  },
  filters: {
    getCustomValue: function (value, key,type) {
      if (value && Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          if (value[i].attribute_id === key) {
            if(type === "DateTime"){
              if(value[i].value){
                return moment(value[i].value, "YYYY-MM-DD").format("DD.MM.YYYY");
              }
            }
            return value[i].value;
          }
        }
      } else {
        return "";
      }
    }
  },
  watch: {
    ClientContractID: async function (val, old) {
      if (!val) {
        return this.$router.push(`/v2/contract-client`)
      }
      if (val && old && val.id && old.id && val.id != old.id) {
        this.selected = []
        this.propertySelected = null
        this.refreshProperty();
        this.reloadEquipmentStruct();
      }
      if(val){
        this.checkShowBtn();
      }
    }
  },
  computed: {
    ...mapGetters({
      ClientContractID: "ContractController/ClientContractID"
    })
  },
  created() {
    this.checkShowBtn();
  },
  methods: {
    checkShowBtn() {
      let controls = {
        create: this.$checkRole(this.$accessModule.equipment, 'create'),
        delete: this.$checkRole(this.$accessModule.equipment, 'delete'),
      }
      if (this.ClientContractID && this.ClientContractID.status == 'Reopening') controls.delete = false;
      this.tableConfig.controls = controls
    },
    getColumnSettings(settings) {
      this.columnSettings = settings;
    },
    openPreventive() {
      this.modals.preventive.open = true
      this.modals.preventive.selected = this.$refs.gofixTable.tableSelected.selected;
    },

    /* --- Equipment --- */
    async getTableData(callback) {
      const {tableRequest, resolve, reject} = await callback();

      // if (!tableRequest.filter.contract_id.value) {
      //   tableRequest.filter.contract_id.value = this.$route.params.id;
      // }
      if(!tableRequest.filter.contract_id.value) {
        this.tableItems = [];
        this.tableConfig.total = 0;
        resolve({ items: [], total: 0 });
        return;
      }

      tableRequest.filter.location_id.value = this.pages.filter.location_id.value;
      tableRequest.filter.equipment_group_id.value = this.pages.filter.equipment_group_id.value;

      if(!tableRequest.filter.equipment_status.value || (tableRequest.filter.equipment_status.value && tableRequest.filter.equipment_status.value.length == 0)) {
        tableRequest.filter.equipment_status.value = ['Active', 'Shutdown'];
      }

      await this.$store.dispatch("EquipmentV2Controller/getEquipments", tableRequest)
          .then(response => {
            this.tableItems = response.data.data.items;
            this.tableConfig.total = response.data.data.total;
            resolve(response.data.data);
          })
          .catch(err => {
            console.log(err);
            this.$alertNotification("Can not load the equipments", "danger");
            reject();
          })
    },
    async deleteItems(callback) {
      const {ids, filter, resolve, reject} = await callback();
      this.$store.dispatch("EquipmentV2Controller/deleteEquipment", ids)
          .then(response => {
            resolve(response.data.data);
          })
          .catch(err => {
            reject(err);
          });
    },
    reloadEquipment() {
      this.$refs.gofixTable.reloadTableKeepFilter();
    },
    addItem() {
      if (!this.$checkRole(this.$accessModule.equipment, 'create')) {
        return
      }

      if (this.categorySelected && this.categorySelected.data) {
        this.treeSelected.groups = this.categorySelected.data;
      }

      if (this.propertySelected) {
        this.treeSelected.location = this.propertySelected;
      }

      this.modals.addEquipment.open = true;
    },
    moreItem(item) {
      this.$store.commit('EquipmentV2Controller/setEquipment', item);
      return this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment/${item.id}`);
    },

    /* --- Tree Property --- */
    getData() {
      return new Promise((resolve, reject) => {
        this.loadingProperty = true;
        global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
          method: "GET",
          params: {
            is_active: true
          },
          headers: {
            Accept: "application/json"
          }
        })
            .then(response => {
              this.rootId = response.data.data[0].data.id;
              this.loadingProperty = false;
              if (response.data.data && response.data.data[0] && response.data.data[0].children) {
                response.data.data[0].children.forEach((element, key) => {
                  response.data.data[0].children[key].data.address = element.get_address;
                });
              }
              resolve(response.data.data);
            })
            .catch(error => {
              this.loadingProperty = false;
              reject(error);
            });
      });
    },
    selectProperty(node, status) {
      this.propertySelected = node.data;
      this.pages.filter.location_id.value = node.parent ? node.data.id : '';
      this.propertySelected.addessText = '';
      if (this.propertySelected.address) {
        this.propertySelected.addessText = this.propertySelected.address.display_address;
      }
      if (!status) this.reloadEquipment();
    },
    refreshProperty() {
      this.loadingProperty = true;
      global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
        method: "GET",
        data: {},
        headers: {
          Accept: "application/json"
        }
      })
          .then(response => {
            this.loadingProperty = false;
            if (response.data.data && response.data.data[0] && response.data.data[0].children) {
              response.data.data[0].children.forEach((element, key) => {
                response.data.data[0].children[key].data.address = element.get_address;
              });
            }
            this.$refs.treeViewProperties.setModel(response.data.data);
          })
          .catch(error => {
            this.loadingProperty = false;
          });
    },

    /* --- Tree Equipment Group --- */
    getCateData() {
      return this.$store
          .dispatch("EquipmentV2Controller/getEquipmentCategory", {
            id: 0,
            contract_id: this.$route.params.id
          })
          .then(response => {
            this.CategoryrootId = response.data.data[0].data.id;
            this.loadingEquipmentStruct = false;
            return response.data.data;
          });
    },
    selectCategory(node, status) {
      this.categorySelected = node;
      if (!node.data.parent_id) {
        this.pages.filter.equipment_group_id.value = null;
      } else {
        this.pages.filter.equipment_group_id.value = node.id;
      }
      if (!status) this.reloadEquipment();
    },
    reloadEquipmentStruct() {
      this.loadingEquipmentStruct = true;
      this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
        id: 0,
        contract_id: this.$route.params.id
      })
          .then(response => {
            this.loadingEquipmentStruct = false;
            this.$refs.treeViewCategory.setModel(response.data.data);
          });
    },

    /*--- Import File ---*/
    async importEquipmentAction(callback) {
      const {file, resolve, reject} = await callback();
      await this.$store.dispatch(`EquipmentV2Controller/import`, {
        id: this.$route.params.id,
        fileImport: file
      })
          .then(response => {
            let variant = 'success';
            let msg = this.$notificationV2('importing', 'equipment');
            let result = response.data.data;
            if (result.data && result.data.count && result.data.count.failed) {
              variant = 'danger';
              msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
            }

            this.$alertNotification(msg, variant);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
    },
    async uploadFileImport(callback) {
      const {file, resolve, reject} = await callback();
      this.$store.dispatch(`EquipmentStructureController/uploadFileImport`, {
        contract_id: this.$route.params.id,
        file: file,
        is_master: false
      })
          .then(response => {
            this.pages.filter.equipment_type.value = null;
            this.pages.filter.equipment_group_id.value = null;
            this.reloadEquipment();

            this.loadingEquipmentStruct = true;
            this.getCateData().then(result => {
              this.loadingEquipmentStruct = false;
              this.$refs.treeViewCategory.tree.setModel(result);
            });

            resolve({
              result: response.data.data,
              msg_success: this.$notificationV2('importing', 'equipment')
            });
          })
          .catch(err => {
            reject(err);
          })
    },
    async uploadFileImportCustomfields(callback) {
      const {file, resolve, reject} = await callback();
      this.$store.dispatch(`EquipmentStructureController/importCustomFields`, {
        contract_id: this.$route.params.id,
        file: file
      })
          .then(response => {
            resolve({
              result: response.data.data,
              msg_success: this.$notificationV2('importing', 'equipment_group_custom_field')
            });
          })
          .catch(err => {
            reject(err);
          })
    },
    async exportItems(){
      let params = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
      if (!params.filter.contract_id.value) {
        params.filter.contract_id.value = this.$route.params.id;
      }
      params.filter.location_id.value = this.pages.filter.location_id.value;
      params.filter.equipment_group_id.value = this.pages.filter.equipment_group_id.value;
      params.contract_id = this.$route.params.id;
      params.limit = -1;

      if(!params.filter.equipment_status.value || (params.filter.equipment_status.value && params.filter.equipment_status.value.length == 0)) {
        params.filter.equipment_status.value = ['Active', 'Shutdown'];
      }

      let that = this;
      this.modals.export.open = true;
      this.modals.export.process = "Creating file csv";
      await global.axios('/api/equipment/export', {
        method: "GET",
        params: params,
        responseType: 'blob',
        onDownloadProgress (progress) {
          that.modals.export.process = "Downloading";
        }
      })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Equipments.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.modals.export.open = false
          })
          .catch(error => {
            this.modals.export.open = false
            console.log(error);
          });
    }
  }
    }
</script>
